import { render, staticRenderFns } from "./AnswerArea.vue?vue&type=template&id=19f71396&scoped=true&"
import script from "./AnswerArea.vue?vue&type=script&lang=js&"
export * from "./AnswerArea.vue?vue&type=script&lang=js&"
import style0 from "./AnswerArea.vue?vue&type=style&index=0&id=19f71396&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f71396",
  null
  
)

export default component.exports